<template>
  <div class="container-fluid">
    <div class="container-fluid">
      <div class="row" id="dashboardCardDiv">
        <div class="col-md-12">
          <div class="card card-transparent-background">
            <div class="card-header card-header-icon row mr-0">
              <div class="col-6 pl-0">
                <h4 class="card-title card-title-irish-date">Users</h4>
              </div>
              <div class="col-6 pr-0">
                <b-button
                  variant="mid-primary"
                  id=""
                  class="btn btn-bumblebee btn-mid btn-filter m-0 float-right"
                >
                  <font-awesome-icon icon="fa-solid fa-download" class="mr-1" />
                  Export CSV
                </b-button>
              </div>
              <!-- <div class="col-6">
                <export-excel
                  class="btn btn-mid-primary btn-filter m-0 float-right"
                  :fields="json_fields"
                  :fetch="clickExport"
                  type="xls"
                  name="Users.xls"
                >
                  <font-awesome-icon icon="fa-solid fa-download" class="mr-1" />
                  Export CSV
                </export-excel>
                <download-excel
                  :data="rowsData"
                  :export-fields="json_fields"
                  class="btn btn-mid-primary btn-filter m-0 float-right"
                 
                  :meta="json_meta"
                >
                  Download Data
                </download-excel>
              </div> -->
            </div>
          </div>
          <b-overlay
            :show="overlay_show"
            rounded="sm"
            variant="mid-primary"
            opacity="0.5"
            blur="2px"
          >
            <div class="row">
              <div class="col-md-12">
                <div class="card mt-1">
                  <div class="card-body">
                    <b-table-simple
                      class="
                        table table-no-bordered table-hover
                        myIrishDateTable
                      "
                      id="usersTable"
                      hover
                      responsive
                    >
                      <b-thead>
                        <b-tr>
                          <b-th></b-th>
                          <b-th>Name</b-th>
                          <b-th>Email</b-th>
                          <b-th>Number</b-th>
                          <b-th>Account</b-th>
                          <b-th>Payment</b-th>
                          <b-th>Subscriptions</b-th>
                          <b-th>Actions</b-th>
                        </b-tr>
                      </b-thead>
                      <b-tbody>
                        <b-tr v-for="user in rowsData" :key="user.id">
                          <b-td class="select-checkbox"
                            ><input
                              type="checkbox"
                              name="selectedUsers[]"
                              v-bind:value="user.id"
                          /></b-td>
                          <b-td>{{ user.name }}</b-td>
                          <b-td>{{ user.email }}</b-td>
                          <b-td>{{ user.phone }}</b-td>
                          <b-td>Free</b-td>
                          <b-td></b-td>
                          <b-td></b-td>
                          <b-td class="centerTd">
                            <b-button
                              variant="action"
                              class="mb-1"
                              @click="deleteUser(user.id)"
                              ><img
                                src="@/assets/images/my-irish-date/delete-action-icon.png"
                                alt="mid icon" /></b-button
                          ></b-td>
                        </b-tr>
                      </b-tbody>
                    </b-table-simple>
                  </div>
                </div>
              </div></div
          ></b-overlay>
        </div>
      </div>
    </div>
    <!-- delete modal -->
    <DeleteUser :user_id="selected_user_id" />
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";
import DeleteUser from "./DeleteUser.vue";

import Vue from "vue";
import excel from "vue-excel-export";
Vue.use(excel);

import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);


var table;
export default {
  name: "MIDUsersList",
  components: { DeleteUser },
  data() {
    return {
      // rowsData: [
      //   {
      //     id: 1,
      //     name: "Sara Reda",
      //     email: "sara@bumblebeeai.io",
      //     number: "01276541628",
      //     account: "Free",
      //     payment: "",
      //     subscriptions: null,
      //   },
      //   {
      //     id: 2,
      //     name: "Sara Reda",
      //     email: "sara@bumblebeeai.io",
      //     number: "01276541628",
      //     account: "Premium",
      //     payment: "Visa card",
      //     subscriptions: 10,
      //   },
      // ],
      overlay_show: false,
      rowsData: [],

      columns: [
        { label: "", key: "select", className: "select-checkbox" },
        { label: "Name", key: "name", data: "name" },
        { label: "Email", key: "email", data: "email" },
        { label: "Number", key: "phone", data: "number" },
        { label: "Account", key: "account", data: "account" },
        { label: "Payment", key: "payment", data: "payment" },
        {
          label: "Subscriptions",
          key: "subscriptions",
          data: "subscriptions",
          class: "centerTd",
        },
        { label: "Actions", key: "actions", class: "centerTd" },
      ],
      selected_user_id: null,
      table: null,
      json_fields: {
        ID: "id",
        Name: "name",
        Email: "email",
        Phone: "phone",
        Country: "country",
        Age: "age",
        // Words: {
        //   field: "words",
        //   callback: (values) => {
        //     let value = "";
        //     console.log(values);
        //     for (let i = 0; i < values.length; i++) {
        //       console.log(values[i]);
        //       value += values[i].name + ",";
        //     }
        //     return value;
        //   },
        // },
      },
      json_data: [],
      json_data2: [
        {
          name: "Tony Peña",
          city: "New York",
          country: "United States",
          birthdate: "1978-03-15",
          phone: {
            mobile: "1-541-754-3010",
            landline: "(541) 754-3010",
          },
        },
        {
          name: "Thessaloniki",
          city: "Athens",
          country: "Greece",
          birthdate: "1987-11-23",
          phone: {
            mobile: "+1 855 275 5071",
            landline: "(2741) 2621-244",
          },
        },
      ],
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
    };
  },
  methods: {
    deleteUser(id) {
      // console.log("delete event ", id);
      this.selected_user_id = id;
      this.$root.$emit("bv::show::modal", "deleteModal");
    },
    getUserList() {
      // console.log("here call user list");
      // console.log(JSON.parse(window.localStorage.getItem("user")).access_token);
      axios
        .get("/admin/users", {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: "MID",
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          // console.log(table);
          // table.destroy();
          if (table != null) {
            table.destroy();
          }
          console.log(response);
          // console.log(this.rowsData);
          this.rowsData = response.data;
          this.json_data = response.data;
          // console.log(this.rowsData);
          var temp = this;
          setTimeout(function () {
            // console.log(table);
            // console.log(table == null);
            if (table == null) {
              temp.initTable();
            } else {
              // console.log(table.data());
              temp.initTable();
              // console.log(table.data());
              // table.destroy();
              // $('#sampleTable').DataTable().clear()
              // $('#sampleTable').DataTable().destroy()
              //
            }
          }, 1000);
          this.overlay_show = false;
          // table.ajax.reload()
        });
    },
    initTable() {
      table = $("#usersTable").DataTable({
        sDom: 'flti<"table_selected_rows">p',
        // buttons: [
        //    'csv',
        // ],
        ordering: false,
        info: true,
        destroy: true,
        // responsive: true,
        // scrollY: "450px",
        // scrollCollapse: true,
        searching: true,
        lengthMenu: [
          [-1, 5, 10, 25, 50, 100],
          ["All", 5, 10, 25, 50, 100],
        ],
        // columns: this.$parent.columns,
        // data: this.$parent.rowsData,
        language: {
          paginate: {
            previous: "<i class='fas fa-angle-left'></i>",
            next: "<i class='fas fa-angle-right'></i>",
          },
          search: "",
          searchPlaceholder: "Search ",
        },
        columnDefs: [
          {
            orderable: false,
            className: "select-checkbox",
            targets: 0,
          },
        ],
        select: {
          style: "multi",
        },
      });
      
table.buttons().container()
    .appendTo( $('.col-sm-6:eq(0)', table.table().container() ) );

      // $("#selectAll").change(function () {
      //   console.log(table.rows());

      //   if (this.checked) {
      //     table.rows().every(function () {
      //       $(this.node()).addClass("selected");
      //       $(this.node()).children().children().attr("checked", "checked");
      //       console.log($(this.node()));
      //       console.log($(this.node()).children());
      //       console.log($(this.node()).children().children());
      //     });
      //   } else {
      //     table.rows().every(function () {
      //       $(this.node()).removeClass("selected");
      //       $(this.node()).children().children().attr("checked", false);
      //     });
      //   }
      //   console.log($('input[name="selectedUsers[]"]:checked'));
      //   $("#selectAll").val(this.checked);
      // });
      $("#usersTable tbody")
        .off()
        .on("click", "tr td:first-child", function () {
          // console.log(table.row(this).data());
          $(this).parent().toggleClass("selected");
          if ($(this).children().is(":checked")) {
            $(this).children().attr("checked", false);
          } else {
            $(this).children().attr("checked", "checked");
          }
          // console.log($('input[name="selectedUsers[]"]:checked'));
          $(".table_selected_rows").html(
            $('input[name="selectedUsers[]"]:checked').length +
              " row(s) selected"
          );
        });

      // table.on("selectItems", function (e, dt, items) {
      //   console.log("Items to be selected are now: ", items);
      // });
      // table.on("user-select", function (e, dt, type, cell, originalEvent) {
      //   var row = dt.row(cell.index().row);
      //   console.log(row.data()[6]);

      //   if ($(originalEvent.target).children().is(":checked")) {
      //     $(originalEvent.target).children().attr("checked", false);
      //   } else {
      //     $(originalEvent.target).children().attr("checked", "checked");
      //   }
      // });
    },
    clickExport() {
      console.log("click export generate");
      console.log($('input[name="selectedUsers[]"]:checked'));
      let selectedIDs = [];
      $('input[name="selectedUsers[]"]:checked').each(function () {
        selectedIDs.push($(this).val());
      });
      console.log(selectedIDs);
      if (selectedIDs.length > 0) {
        this.json_data = [];
        for (let i = 0; i < this.rowsData.length; i++) {
          console.log(this.rowsData[i]);
          if (selectedIDs.includes("" + this.rowsData[i].id)) {
            this.json_data.push(this.rowsData[i]);
          }
        }
      } else {
        this.json_data = this.rowsData;
      }
      console.log(this.json_data);
      return this.json_data;
    },
  },
  mounted() {
    this.overlay_show = true;
    this.initTable();
    this.getUserList();
    // var tt = this;
    // setTimeout(function () {
    //   // table.clear();
    //   // table.destroy();
    //   tt.getUserList();
    //   table.draw();
    // }, 10000);
    // console.log(window.localStorage.getItem("user"));
    //
  },
};
</script>
<style scoped>
@import "https://cdn.datatables.net/select/1.3.3/css/select.dataTables.min.css";
</style>


// WEBPACK FOOTER //
// src/components/my_irish_date/users/List.vue